"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uuid = exports.slug = exports.passwordRequirements = exports.password = exports.emailAddress = void 0;

/**
 * Password size.
 */
var passwordSize = '.{8,}';
/**
 * Password number.
 */

var passwordNumber = '.*\\d';
/**
 * Password lowercase.
 */

var passwordLowercase = '.*[a-z]';
/**
 * Password uppercase.
 */

var passwordUppercase = '.*[A-Z]';
/**
 * Export `password`.
 */

var password = "^.*(?=".concat(passwordSize, ")(?=").concat(passwordNumber, ")(?=").concat(passwordLowercase, ")(?=").concat(passwordUppercase, ").*$");
/**
 * Export `passwordRequirements`.
 */

exports.password = password;
var passwordRequirements = {
  lowercase: passwordLowercase,
  number: passwordNumber,
  size: passwordSize,
  uppercase: passwordUppercase
};
/**
 * Export `slug`.
 */

exports.passwordRequirements = passwordRequirements;
var slug = '^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$';
/**
 * Export `uuid`.
 */

exports.slug = slug;
var uuid = '[0-9a-fA-F]{8}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{4}\\-[0-9a-fA-F]{12}';
/**
 * Export `emailAddress`.
 */

exports.uuid = uuid;
var emailAddress = '.+@[^@]+\\.[^@]{2,}$';
exports.emailAddress = emailAddress;